import { GlobalsService } from './globals.service';

import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import { DispatchBoardSearch } from '../models/DispatchBoardSearch';
import * as _ from 'lodash';
import { v_EmployeeSearchBus } from '../models/v_EmployeeSearchBus';
import { GItem } from '../models/GItem';
import { FileInfo } from '@progress/kendo-angular-upload';
import { PersonTrainingBus } from '../models/PersonTrainingBus';
import { EmployeeDocumentBus } from '../models/EmployeeDocumentBus';

@Injectable()
export class EmployeeService extends BaseService {

    public trainingCategories: GItem[] = [];
    trainingData: PersonTrainingBus[] = [];
    employeeDocumentData: EmployeeDocumentBus[] = [];

    constructor(_http: HttpClient, private globalsService: GlobalsService) {
        super(_http);
        this.baseUrl = this.rootUrl + "Employee/";
    }

    getViewById(url: string, Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetViewById/" + Id;
        return this.get(url_call);
    }

    getById(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + Id;
        return this.get(url_call);
    }
    getEmployeeLookup(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEmployeeLookup/" + Id;
        return this.get(url_call);
    }
    search(search: string,isActive: boolean): Observable<v_EmployeeSearchBus[]> {
        if (search === undefined || search === null || search.length === 0)
            return;
        let searchType = "All/"
        if (isActive) { searchType = "Active/"}
        let url_call: string = this.baseUrl + "Search/" + searchType+ search;
        return this.get(url_call); //, { headers: headers });
    }
    save(model: any) : Observable<any> {
      let headers = this.getHeaders();
      let url_call: string = this.baseUrl + "Save";
        return this._http.put(url_call, model, { headers });
    }
    GetReferenceData(): Observable<any> {
        let url_call: string = this.baseUrl + "GetReferenceData";
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        return this._http.get(url_call, options);
       // return this.get(url_call);
    }
    GetReferenceDataTraining(): Observable<any> {
        let url_call: string = this.baseUrl + "GetReferenceDataTraining";
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        return this._http.get(url_call, options);
        // return this.get(url_call);
    }
    getTimeoffRequests(Id: string): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetTimeoffRequests/" + Id;
        return this._http.get(url_call, options);
    }

    checkForUserWaivers(Id: string): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "CheckForUserWaivers/" + Id;
        return this._http.get(url_call, options);
    }
    saveWaiverResponse(id: string, value: string): Observable<any> {
        let model = {
            waiverId: id,
            userResponse:value
        }
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveWaiverResponse";
        return this._http.put(url_call, model, { headers });
    }
    GetTimeoffRequestsMaintain(Id: number): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetTimeoffRequestsMaintain/" + Id;
        return this._http.get(url_call, options);
    }
    getRequestTimeOffReferenceData(id: string = null): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetRequestTimeOffReferenceData";
        if (id !== null) {
            url_call = url_call + '/' + id;
        }
        return this._http.get(url_call, options);
    }

    saveNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveNote";
        return this._http.put(url_call, model, { headers });
    }
    saveEmployeeDocument(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveEmployeeDocument";
        return this._http.put(url_call, model, { headers });
    }
    deleteEmployeeDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeleteEmployeeDocument/" + id;
        return super.get(url_call);
    }
    deletePersonTraining(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeletePersonTraining/" + id;
        return super.get(url_call);
    }
    saveTraining(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePersonTraining";
        return this._http.put(url_call, model, { headers });
    }
    saveTimeoffRequest(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveTimeOffRequest";
        return this._http.put(url_call, model, { headers });
    }
    getPersonTraining(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "PersonTraining/" + Id;
        return this.get(url_call);
    }
    getEmployeeDocuments(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "EmployeeDocuments/" + Id;
        return this.get(url_call);
    }
    getPerson(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetPerson/" + Id;
        return this.get(url_call);
    }
    saveTimeEntry(model: any): Observable<any> {
        let headers = this.getHeaders();

        let url_call: string = this.baseUrl + "SaveTimeEntry";
        return this._http.put(url_call, model, { headers });
    }
    getTimeEntriesCurrentWeek(Id: string): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetTimeEntriesCurrentWeek/" + Id;
        // return this._http.get(url_call); //, { headers: headers }); //, { headers: headers });

        return this._http.get(url_call, options);
    }
    GetUserSettings(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetUserSettings";
        // return this._http.get(url_call); //, { headers: headers }); //, { headers: headers });

        return this._http.get(url_call, options);
    }
    saveUserSettings(model: any): Observable<any> {
        let headers = this.getHeaders();

        let url_call: string = this.baseUrl + "SaveUserSettings";
        return this._http.put(url_call, model, { headers });
    }
    getTechsByFilter(search: DispatchBoardSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "dispatchboardsearch", s_search);
        let url_call: string = this.baseUrl + "GetTechPanelByIds";
        return this._http.get(url_call, options);
    }

    employeeUserFeatures(employeeId: string): Observable<any> {
        return this.get(this.baseUrl + 'EmployeeUserFeatures/' + employeeId);
    }

    templateUserFeatures(secTemplateId: string): Observable<any> {
        return this.get(this.baseUrl + 'TemplateUserFeatures/' + secTemplateId);
    }

    saveAttachment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAttachment";
        return this._http.put(url_call, model, { headers });
    }

    getDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetTrainingDocument/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }

    getEmployeeDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetS3EmploymentDocumentAttachment/" + id;
        return super.get(url_call); // this.get(url_call); //, { headers: headers });
    }

    getEmployeePhoto(id: string): Observable<any> {

        let url_call: string = this.baseUrl + "GetEmployeePhoto/" + id;
        return super.get(url_call);
    }

    uploadAttachment(files: FileInfo[], attachmentName: string): Observable<any> {
        let url: string = this.baseUrl + "UploadAttachment";
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", attachmentName);

        return this._http.put(url, formData);
    }

    uploadEmployeeDocumentAttachment(files: FileInfo[], attachmentName: string): Observable<any> {
        let url: string = this.baseUrl + "UploadEmployeeDocumentAttachment";
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", attachmentName);

        return this._http.put(url, formData);
    }

    uploadPhoto(files: FileInfo[], attachmentName: string): Observable<any> {
        let url: string = this.baseUrl + "UploadEmployeePhoto";
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", attachmentName);

        return this._http.put(url, formData);
    }

    set EmployeeTrainingData(trainingData: PersonTrainingBus[]) {
        this.trainingData = trainingData;
    }

    get EmployeeTrainingData() {
        return this.trainingData;
    }

    set EmployeeDocumentData(docData: EmployeeDocumentBus[]) {
        this.employeeDocumentData = docData;
    }

    get EmployeeDocumentData() {
        return this.employeeDocumentData;
    }
    getEmployeeExport(ActiveOnly:Boolean): Observable<any> {
        let url_call: string = this.baseUrl + "EmployeeExport";
        if (ActiveOnly) { url_call = url_call+"/TRUE"}
        else { url_call = url_call + "/FALSE" }
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    getEmployeeExportCon(ActiveOnly: Boolean): Observable<any> {
        let url_call: string = this.baseUrl + "EmployeeExportCon";
        if (ActiveOnly) { url_call = url_call + "/TRUE" }
        else { url_call = url_call + "/FALSE" }
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    saveDepartments(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDepartments";
        return this._http.put(url_call, model, { headers });
    }
    getDepartments(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetDepartments" ;
        return this._http.get(url_call, options);
    }
    saveJobRoles(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveJobRoles";
        return this._http.put(url_call, model, { headers });
    }

    SaveAllTimeOffRequest(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAllTimeOffRequest";
        return this._http.put(url_call, model, { headers });
    }
    getJobRoles(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetJobRoles";
        return this._http.get(url_call, options);
    }
    saveJobTitles(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveJobTitles";
        return this._http.put(url_call, model, { headers });
    }
    getJobTitles(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetJobTitles";
        return this._http.get(url_call, options);
    }
    saveSecJobRoles(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSecJobRoles";
        return this._http.put(url_call, model, { headers });
    }
    getSecJobRoles(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetSecJobRoles";
        return this._http.get(url_call, options);
    }
    saveCostCenter(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveCostCenter";
        return this._http.put(url_call, model, { headers });
    }
    getCostCenters(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetCostCenters";
        return this._http.get(url_call, options);
    }
    saveUnion(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveUnion";
        return this._http.put(url_call, model, { headers });
    }
    getUnions(): Observable<any> {
        var userid = this.globalsService.userId;
        let options = this.getOptionsU(userid);
        let url_call: string = this.baseUrl + "GetUnions";
        return this._http.get(url_call, options);
    }

}
